import { createElement, forwardRef } from 'react';
import { box } from '../patterns/box.js';
import { splitProps } from '../helpers.js';
import { styled } from './factory.js';

export const Box = /* @__PURE__ */ forwardRef(function Box(props, ref) {
  const [patternProps, restProps] = splitProps(props, box.propKeys)
  const styleProps = box.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})